module.exports = __webpack_public_path__ + "static/media/Returns.10343281.svg";